import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=99b8aab2&scoped=true&"
import script from "./sub.vue?vue&type=script&lang=js&"
export * from "./sub.vue?vue&type=script&lang=js&"
import style0 from "./sub.vue?vue&type=style&index=0&id=99b8aab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b8aab2",
  null
  
)

export default component.exports